// ** React Imports
import { lazy } from "react"

const KpisConfigIndex = lazy(() => import('../../views/kpisconfig/list'))

const KpisConfig = [
  {
    path: '/kpisconfig/list',
    element: <KpisConfigIndex/>
  }
]

export default KpisConfig